import { Injectable } from '@angular/core';
import confetti from 'canvas-confetti';

@Injectable({
  providedIn: 'root'
})
export class ConfettiService {
  private canCelebrate: boolean = true;
  private cooldownTime: number = 20000; 

  constructor() {}

  launchConfetti() {
    if (this.canCelebrate) {
      confetti({
        particleCount: 150,
        spread: 80,
        origin: { y: 0.6 }
      });
      
      this.canCelebrate = false; 
       setTimeout(() => {
        this.canCelebrate = true;
      }, this.cooldownTime);
    }
  }
}
